import { memo, useMemo } from 'react';

import { PublicBoardAssetModalDesktopLayout } from '~/components/AssetModalV2/PublicBoardAssetModalDesktopLayout';
import { PublicAssetModalShell } from '~/components/PublicAssetModal/PublicAssetModalShell';
import { usePublicAssetModalNavigation } from '~/providers/PublicAssetModalNavigationProvider';

export const PublicBoardAssetModal = memo(() => {
  // The surface's asset-modal navigation contract owns the close; it rides props from here down to the
  // close consumers (the header's close button, the layout's esc-key handler).
  const { onCloseAssetModal } = usePublicAssetModalNavigation();

  const desktop = useMemo(
    () => <PublicBoardAssetModalDesktopLayout onCloseAssetModal={onCloseAssetModal} />,
    [onCloseAssetModal],
  );

  return <PublicAssetModalShell desktop={desktop} />;
});

PublicBoardAssetModal.displayName = 'PublicBoardAssetModal';
